import React from "react";
import Alert from "@material-ui/lab/Alert";
import {
  makeStyles,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  clickableAlert: {
    marginBottom: theme.spacing(3),
    cursor: "pointer",
  },
}));

export default function CustomerMessagePage(props) {
  const { showMsg } = props;
  const history = useHistory();
  const classes = useStyles();

  return (
    <>
      {!showMsg ? (
        <></>
      ) : (
        <Alert
          severity="error"
          className={`${classes.clickableAlert}`}
          onClick={() => {
            history.replace("/logout");
          }}
        >
          {showMsg} 點擊此處重新登入
        </Alert>
      )}
    </>
  );
}
